import React, { useState, useEffect } from 'react';
import UserRoleFormPopup from './UserRoleFormPopup';
import { getPermissions, getRoles } from '../../../actions/organization';
import isArray from 'lodash.isarray';
import CustomPagination from '../../Promotion/CustomPagination';
import { useSelector } from 'react-redux';

const RoleManagement = ({ subject = null, brandId = null }) => {
  const { organizationTree } = useSelector((state) => state?.organization);
  const { userPermissions } = useSelector((state) => state?.user || {});

  const [permissions, setPermissions] = useState([]);
  const [roles, setRoles] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [pageOffset, setPageOffset] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  useEffect(() => {
    getPermissionsFunc();
  }, []);

  useEffect(() => {
    if (organizationTree?.organizationId) {
      getRolesFunc();
    }
  }, [pageOffset, organizationTree]);

  const getPermissionsFunc = async () => {
    try {
      const res = await getPermissions();
      if (res?.length > 0 && isArray(res)) {
        setPermissions([...res]);
      } else {
        setPermissions([]);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const getRolesFunc = async () => {
    try {
      const data = {
        input: {
          pageSize: pageSize,
          pageOffset: pageOffset,
          filters: {
            subject: subject,
            brandId: brandId,
            organizationId: organizationTree?.organizationId,
          },
        },
      };
      const res = await getRoles(data);

      if (res?.roles?.length > 0 && isArray(res?.roles)) {
        setRoles([...res?.roles]);
        setTotalPages(res?.totalPages);
      } else {
        setRoles([]);
        setTotalPages(0);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const updateHandler = () => {
    try {
      getRolesFunc();
    } catch (e) {
      console.log(e);
    }
  };

  const canManageRole =
    userPermissions?.includes('manage_all') ||
    userPermissions?.includes('manage_role');

  const canViewRoleList =
    userPermissions?.includes('manage_all') ||
    userPermissions?.includes('manage_role') ||
    userPermissions?.includes('list_role');

  return (
    <div className="page-content">
      <div className="d-flex flex-row align-items-center justify-content-between">
        <h5>User Roles</h5>
        {canManageRole ? (
          <UserRoleFormPopup
            subject={subject}
            updateHandler={updateHandler}
            permissions={permissions}
            roles={roles}
            brandId={brandId}
          />
        ) : null}
      </div>
      {canViewRoleList ? (
        <div className="mt-4">
          <table className="table table-nowrap table-centered align-middle mb-0">
            <thead className="bg-light fs-14">
              <tr>
                <th>#</th>
                <th>Name</th>

                <th>Actions</th>
              </tr>
            </thead>
            <tbody className="fs-13">
              {roles?.map((role, index) => {
                return (
                  <tr key={role?._id}>
                    <td>{index + 1}</td>
                    <td>{role?.name}</td>
                    <td>
                      <UserRoleFormPopup
                        subject={subject}
                        updateHandler={updateHandler}
                        permissions={permissions}
                        roles={roles}
                        role={role}
                        brandId={brandId}
                      />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          <CustomPagination
            pageOffset={pageOffset}
            totalPages={totalPages}
            setPageOffset={setPageOffset}
          />
        </div>
      ) : null}
    </div>
  );
};

export default RoleManagement;
